import React from "react";
import {
  Card,
  CardHeader,
  CardFooter,
  CardTitle,
  CardDescription,
} from "@/components/ui/card";
import { Avatar, AvatarFallback, AvatarImage } from "../ui/avatar";
import { Button } from "../ui/button";
import { PhoneCallIcon, X } from "lucide-react";

interface ProfileCardProps {
  name: string;
  et_id: string;
  vehicle_number: string;
  phone: string;
  onClose: () => void; // New prop for the close button handler
  avatarSrc?: string; // Optional prop for avatar image source
}

export const ProfileCard: React.FC<ProfileCardProps> = ({
  name,
  et_id,
  vehicle_number,
  phone,
  onClose,
  avatarSrc,
}) => {
  const avatarFallback = name
    .split(" ")
    .map((n) => n[0])
    .join("");

  return (
    <Card className="relative shadow-[0px_4px_10px_17px_rgba(0,0,0,0.04)] rounded-xl bg-white w-[334px]">
      <button
        onClick={onClose}
        className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
      >
        <X />
      </button>
      <CardHeader className="flex flex-row justify-center gap-2">
        <Avatar className="h-15">
          <AvatarImage src={avatarSrc || ""} />
          <AvatarFallback>{avatarFallback}</AvatarFallback>
        </Avatar>
        <div className="flex flex-col">
          <CardDescription>Driver Name</CardDescription>
          <CardTitle>{name}</CardTitle>
        </div>
      </CardHeader>
      <div className="flex flex-row justify-center pt-1">
        <div className="flex flex-col items-center w-1/2">
          <div>ET ID</div>
          <CardDescription className="font-bold">{et_id}</CardDescription>
        </div>
        <div className="flex flex-col items-center w-1/2">
          <div>Vehicle No.</div>
          <CardDescription className="font-bold">
            {vehicle_number}
          </CardDescription>
        </div>
      </div>
      <CardFooter className="mt-5 flex justify-center">
        <Button
          variant="primary"
          className="flex flex-row justify-center gap-2"
          onClick={() => {
            window.open(`tel:${phone}`, "_blank");
          }}
        >
          <PhoneCallIcon fill="white" strokeWidth={0} />
          Call to Pilot
        </Button>
      </CardFooter>
    </Card>
  );
};
